export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="py-12 border-t border-border/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group">
            <div className="w-10 h-10 border border-primary/60 flex items-center justify-center">
              <span className="font-serif text-primary text-sm font-medium">CR</span>
            </div>
            <div>
              <span className="text-sm font-medium tracking-wide text-foreground">CYBER RISK</span>
              <span className="block text-xs tracking-widest text-muted-foreground">SOLUTIONS</span>
            </div>
          </a>

          {/* Navigation */}
          <nav className="flex flex-wrap gap-8">
            {[
              { label: "Services", href: "#services" },
              { label: "Experience", href: "#experience" },
              { label: "Impact", href: "#impact" },
              { label: "Insights", href: "#insights" },
              { label: "Connect", href: "#connect" },
            ].map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="text-sm text-muted-foreground hover:text-primary transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>

        <div className="mt-12 pt-8 border-t border-border/30 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {currentYear} Cyber Risk Solutions. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            Nick Bell | Cyber, Economic Crime & National Resilience
          </p>
        </div>
      </div>
    </footer>
  )
}
